export const iconFontAwesomeMapsHospital = (
	<i className="fa-solid fa-hospital"></i>
);
